export const enableScroll = () => {
  document.getElementsByTagName('body')[0].style.overflow = 'scroll';
};

export const disableScroll = () => {
  document.getElementsByTagName('body')[0].style.overflow = 'hidden';
};

export const scrollToTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'auto',
  });
};
